import {originClick} from '@aboutyou/legacy-tracking-sdk';
import {useTrackOriginClick} from '@aboutyou/tracking';

const useOriginClickTracking = (originClick: originClick) => {
  const trackingOrigin = useTrackOriginClick();
  return trackingOrigin(originClick);
};

export const useTrackBackButtonOriginClick = () =>
  useOriginClickTracking('brands_related_logos');
